import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputModule } from '@sla-ng/ui-material';
import { JoinCostCenterCostUnitDialogComponent } from './join-cost-center-cost-unit-dialog.component';

export * from './join-cost-center-cost-unit-dialog.component';
@NgModule({
    declarations: [ JoinCostCenterCostUnitDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        TranslateModule,
    ],
})
export class JoinCostCenterCostUnitDialogModule {
}
